import clsx from "clsx";
import { JumpToSection } from "./JumpToSection";
import { useFlags } from "@/utils/flagsmith/useFlags";
import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";

export function KeyRisks() {
    const flags = useFlags();
    const showComingSoon = flags.enabled("show-coming-soon-placeholders");

    if (!showComingSoon) {
        return null;
    }

    return (
        <>
            <div>
                <p
                    className={clsx(
                        "body-s",
                        "text-slate-600 dark:text-slate-300",
                    )}
                >
                    {COMING_SOON}
                </p>
            </div>
            <JumpToSection
                targetSection="returns-and-risk"
                label="Jump to Returns & Risk"
            />
        </>
    );
}
